import { requests } from './api-service';

const rateCategoryApi = {
    getRateCategories: () => requests.get('ratecategories'),
    createRateCategory: (ratecategory) => requests.post('ratecategory', ratecategory),
    updateRateCategory: (ratecategory) => requests.put('ratecategory', ratecategory),
    deleteRateCategory: (id) => requests.delete(`ratecategory/${id}`),
};

export default rateCategoryApi;